import React from "react";
import { FONT_SIZES, FONT_FAMILY } from "../../constants/appConfig";

export const Badge = ({ label, color, small = false }) => (
  <span style={{
    display: "inline-flex", alignItems: "center",
    padding: small ? "2px 8px" : "4px 12px",
    borderRadius: 20,
    fontSize: small ? FONT_SIZES.xs : FONT_SIZES.sm,
    fontWeight: 600, fontFamily: FONT_FAMILY,
    background: `${color}15`, color, border: `1px solid ${color}30`
  }}>{label}</span>
);
